module.exports = __webpack_public_path__ + "static/img/kh.684bc3d2.svg";